var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TaskList',{attrs:{"fstId":("vehicleTasks_" + _vm.getId),"endpoint":_vm.getEndpoint,"qso":_vm.getEndpointOptions,"hideColumns":_vm.columns}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }